class FAQ extends HTMLElement {
    constructor() {
        super();
        this._onTabClick = this._onTabClick.bind(this);
    }

    connectedCallback() {
        this.querySelectorAll('.faq-item-title').forEach((button) => {
            button.addEventListener('click', this.toggleFaqItem.bind(this));
        });

        this.querySelectorAll('.faq__navigation-button').forEach((btn) => {
            btn.addEventListener('click', this._onTabClick);
        });
    }

    toggleFaqItem(e) {
        e.currentTarget
            .querySelector('.faq-close')
            .classList.toggle('faq-display-none');

        const item = e.currentTarget.parentNode.querySelector('.faq-item-text');
        item.slideToggle('250');
        e.currentTarget.parentNode.classList.toggle('faq-item-active');
    }

    _onTabClick(event) {
        const button = event.currentTarget;

        this.querySelectorAll('.faq__navigation-button').forEach((btn) => {
            btn.classList.remove('active');
            btn.setAttribute('aria-selected', 'false');
        });
        button.classList.add('active');
        button.setAttribute('aria-selected', 'true');

        const index = button.getAttribute('data-faq-tab');

        this.querySelectorAll('.faq__panel').forEach((panel) => {
            if (panel.getAttribute('data-faq-panel') === index) {
                panel.removeAttribute('hidden');
            } else {
                panel.setAttribute('hidden', '');
            }
        });
    }
}

customElements.define('faq-container', FAQ);
